import { createEntityAdapter } from '@reduxjs/toolkit';
import { FormInDTO } from '../types';

export const formsAdapter = createEntityAdapter<FormInDTO>({
  selectId: form => form.id,
  sortComparer: (a, b) => b.dateCreated.localeCompare(a.dateCreated),
});
